module.exports = __webpack_public_path__ + "static/media/S36_W.2293c96c.png";